<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.44912 8.42069L1.13019 5.10176L0 6.22399L4.44912 10.6731L14 1.12223L12.8778 0L4.44912 8.42069Z" fill="white"/>
</svg>
